import React, {useState} from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

function Login() {

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    password: ""
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleLogin = async (e) => {
  e.preventDefault();
  try {
      const response = await axios.post(
        "https://api.crm.dsdesigncode.com/api/login/",
        formData
      );

      navigate("/dashboard");

      alert("Login Successful");

    } catch (error) {
      alert("Login Failed");
    }
};

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">

      <div className="w-full max-w-md bg-white p-10 rounded-xl shadow-sm">

        <img
          src="/images/logo.png"
          className="m-auto mb-10"
          alt="logo"
          width={200}
        />

        <h1 className="text-3xl text-center font-bold mb-10">
          Log In
        </h1>
<form onSubmit={handleLogin}>
        {/* Email */}
        <div className="mb-6">
          <label className="block mb-2 text-sm font-medium">
            Email Address
          </label>
          <input
            type="email" name="email" value={formData.email}
              onChange={handleChange}
            className="border w-full h-10 p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
          />
        </div>

        {/* Password */}
        <div className="mb-6">
          <label className="block mb-2 text-sm font-medium">
            Password
          </label>
          <input
            type="password" name="password" value={formData.password}
              onChange={handleChange}
            className="border w-full h-10 p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
          />
        </div>

        {/* Login Button */}
        <button type="submit" className="bg-black text-white p-2 w-full rounded-md mb-3">
          Log In
        </button>
</form>
        {/* Google Login */}
        <button className="bg-white border p-2 w-full rounded-md mb-4">
          Log In with Gmail
        </button>

        {/* Forgot Password */}
        <p className="text-right text-sm">
          <Link to="/forgot-password" className="font-semibold">
            Forgot Password?
          </Link>
        </p>

        {/* Signup */}
        <div className="text-center mt-6 text-sm">
          Don't have an account?
          <Link to="/signup" className="ml-2 font-semibold">
            Sign Up
          </Link>
        </div>

      </div>
    </div>
  );
}

export default Login;
